import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.4997 4C15.8449 4 16.1247 4.27982 16.1247 4.625V6.57731C16.1247 6.92249 15.8449 7.20231 15.4997 7.20231C15.1546 7.20217 14.8747 6.9224 14.8747 6.57731V5.25H10.568V15.0791H12.4512C12.7963 15.0792 13.0762 15.359 13.0762 15.7041C13.076 16.0491 12.7962 16.329 12.4512 16.3291H7.53988C7.19478 16.3291 6.91501 16.0492 6.91488 15.7041C6.91488 15.3589 7.1947 15.0791 7.53988 15.0791H9.31803V5.25H5.11719V6.57731C5.11719 6.92249 4.83737 7.20231 4.49219 7.20231C4.14701 7.20231 3.86719 6.92249 3.86719 6.57731V4.625C3.86719 4.27982 4.14701 4 4.49219 4H15.4997Z",
		fill: "currentColor"
	})
});
export default SvgTextLine;
